angular
	.module('survey.components', [])
	.component('survey', {
		templateUrl: 'ng/components/survey/survey.view.html',
		bindings: {
			/** Required data **/
			elem: '=',
			controllo: '=',
			index: '<',
			titolo: '<',
			//con '&?' gli dico dentro ha una funzione 
			requiredOk: '&?'
		},
		controllerAs: 'SurveyCtrl',
		controller: function ($financialService, $rootScope, $scope) {
			/** not to loose *this reference **/
			var self = this;
			self.$onInit = function () {
				console.log('sono nella survey');
				//Map input
				self.elem = self.elem && self.elem.map(function (v) {
					return {
						'label': v.label,
						'no_label': v.no_label,
						'yes_label': v.yes_label,
						'value': '',
						'required': v.required ? true : false
					}
				});

				console.log('normalized input: ', self.elem);
			}

			self.isRequired = function () {
				var required = self.elem &&
					self.elem.filter(function onlyRequired(v) {
						return v.required === true;
					})
					.length;
				var requiredOk = self.elem.every(function (s) {
					return s.value != '';
				});
				if (requiredOk) {
					self.completo = true;
					return self.requiredOk({
						questionResponse: self.elem
					});
				}
			}
		}
	});